import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ContentContainer from "../components/ContentContainer";
import PageHeader from "../components/PageHeader";
import TechCard from "../components/TechCard";
import "./What.css";

const TECH_CARDS = [
  { icon: "🔐", prefix: "seedSigner" },
  { icon: "💳", prefix: "satochip" },
  { icon: "📱", prefix: "blueWallet" },
];

function What() {
  const { t } = useTranslation();
  return (
    <div className="what">
      <PageHeader 
        title={t("what.title")}
        intro={t("what.intro")}
      />
      
      <ContentContainer>

      <div className="what-tech-cards">
        {TECH_CARDS.map(({ icon, prefix }) => (
          <TechCard key={prefix} icon={icon} prefix={prefix} />
        ))}
      </div>

      <section className="what-section">
        <h2>🔗 {t("what.togetherTitle")}</h2>
        <div className="integration-card">
          <h3>{t("what.togetherStack")}</h3>
          <div className="integration-flow">
            <div className="flow-step">
              <div className="flow-icon">📱</div>
              <h4>{t("what.togetherBlueWallet")}</h4>
              <p>{t("what.togetherBlueWalletDesc")}</p>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-step">
              <div className="flow-icon">📷</div>
              <h4>{t("what.togetherQR")}</h4>
              <p>{t("what.togetherQRDesc")}</p>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-step">
              <div className="flow-icon">🔐</div>
              <h4>{t("what.togetherSeedSigner")}</h4>
              <p>{t("what.togetherSeedSignerDesc")}</p>
            </div>
            <div className="flow-arrow">→</div>
            <div className="flow-step">
              <div className="flow-icon">💳</div>
              <h4>{t("what.togetherSatochip")}</h4>
              <p>{t("what.togetherSatochipDesc")}</p>
            </div>
          </div>
        </div>

        <div className="benefits-grid">
          <div className="benefit-card">
            <h4>🔒 {t("what.benefitSecurity")}</h4>
            <p>
              {t("what.benefitSecurityDesc")}
            </p>
          </div>
          <div className="benefit-card">
            <h4>📱 {t("what.benefitConvenience")}</h4>
            <p>
              {t("what.benefitConvenienceDesc")}
            </p>
          </div>
          <div className="benefit-card">
            <h4>🌐 {t("what.benefitSovereignty")}</h4>
            <p>
              {t("what.benefitSovereigntyDesc")}
            </p>
          </div>
          <div className="benefit-card">
            <h4>💰 {t("what.benefitCost")}</h4>
            <p>
              {t("what.benefitCostDesc")}
            </p>
          </div>
        </div>
      </section>

      <p className="what-why-link">
        {t("what.whyStackPrompt")}
        <Link to="/why">{t("what.whyLinkText")}</Link>.
      </p>
      </ContentContainer>
    </div>
  );
}

export default What;

